// extracted by mini-css-extract-plugin
module.exports = {"container":"QsrDineOption_container__E7E4C"};